<template>
  <div>
    <div class="topImg">
      <img :src="imgUrl" alt="" @click="() => (show = true)" />
      <van-image-preview v-model:show="show" :images="[imgUrl]" />
      <div class="time">时间：{{ time }}</div>
    </div>
    <div class="btns">
      <div class="item" @click="handleGrow">
        <div class="img">
          <img src="./../../../../assets/images/grow.png" />
        </div>
        <div class="label">生育期识别</div>
      </div>
      <div class="item" @click="handlePests">
        <div class="img">
          <img src="./../../../../assets/images/pests.png" alt="" />
        </div>
        <div class="label">病虫害识别</div>
      </div>
      <div class="item" @click="handleNDVI">
        <div class="img">
          <img src="./../../../../assets/images/ndvi.png" alt="" />
        </div>
        <div class="label">
          <div>NDVI</div>
          <div class="fs24">(归一植被指数)</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data () {
    return {
      imgUrl: "",
      result: null,
      time: null,
      show: false,
      point: [],
    };
  },

  mounted () {
    const { imgUrl, time, fileId } = this.$route.query;
    this.imgUrl = imgUrl;
    this.time = time;
    this.fileId = fileId;

    console.log("fileId;", fileId);
  },

  methods: {
    // 生育期
    async handleGrow () {
      this.$router.push({
        path: "/ai/grow",
        query: {
          results: JSON.stringify([{
            name: "开花期",
            score: 0,
          }]),
          fileId: this.fileId,
          imgUrl: this.imgUrl,
        },
      });

      return;

      await this.$toast.loading({
        message: this.$t("common.loading"),
        forbidClick: true,
        duration: 0,
      });

      await this.$api
        .citrusClassification({
          cropFlag: "1",
          imageUrl: this.imgUrl,
        })
        .then((res) => {
          if (res.errcode === 0) {
            if (res.results && res.results.length) {
              this.$router.push({
                path: "/ai/grow",
                query: {
                  results: JSON.stringify(res.results),
                  fileId: this.fileId,
                  imgUrl: this.imgUrl,
                },
              });
            }
          } else {
            this.$toast.fail({
              message: res.errmsg || "不能识别",
            });
          }
        });

      setTimeout(() => {
        this.$toast.clear();
      }, 1000);
    },

    // 病虫害
    async handlePests () {
      this.$toast({
        message: "功能开发中...",
        duration: 2000
      })

      return

      this.$toast.loading({
        message: "图片识别中...",
        mask: true,
        duration: 0,
      });
      await this.$api
        .scanImage({
          cropFlag: 1, //  “1:柑橘 2:杂草 123:苹果 127:葡萄 131:小麦 132:水稻”
          imageUrl: this.imgUrl,
        })
        .then((res) => {
          if (res.errcode === 0) {
            if (!res.content.msg) {
              const result = {
                result: res.content.result,
                core: res.content.score,
                url: this.imgUrl,
              };
              this.result = result;
              // this.core = result.core
              // this.title = result.result

              this.$router.push(
                `/identifyRelut/${encodeURIComponent(
                  JSON.stringify(this.result)
                )}`
              );
            } else {
              this.$toast.fail(res.content.msg || "不能识别");
            }
          } else {
            this.$toast.fail("设备升级中");
          }
        })
        .catch((e) => {
          console.log("e:", e);
        });

      setTimeout(() => {
        this.$toast.clear();
      }, 1500);
    },

    handleNDVI () {
      this.$router.push({
        path: "/ai/ndvi",
        query: {
          imgUrl: this.imgUrl,
          fileId: this.fileId,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.topImg {
  padding: 33px 15px 10px;
  overflow: hidden;

  img {
    border-radius: 12px;
  }
}

.time {
  height: 19px;
  font-size: 14px;
  color: #999999;
  margin-bottom: 32px;
  margin-top: 10px;
  text-align: center;
}

.btns {
  display: flex;
  justify-content: space-between;
  padding: 0 15px;
}

.item {
  flex: 1;
  text-align: center;

  img {
    width: 67px;
    height: 67px;
  }

  .label {
    font-size: 14px;
  }
}

img {
  width: 100%;
  height: 100%;
}
</style>
